module.exports = __webpack_public_path__ + "static/img/ge.2a9da251.png";